import dayjs from "dayjs";
import validate from "validate.js";
import { ValidationField, Validator, dateFormat, email, format, maxLength, presence, range, regExpInvalidCharPattern } from "~/extensions/utils";
import { isNullOrUndefined, MypageMessageFormat } from "~/extensions/utils/DefineFunction";
import { KeyReturnAdrKb, KeyReturnNameKb, RenrakuKb } from "~/extensions/utils/DefineTypes";
import { commonStore } from "~/store/CommonStore";
export class TaikyoNotificationInputValidator extends Validator {
    constructor(vm) {
        const telPattern = /^(?:(?:050|060|070|080|090)-\d{4}-\d{4}|(?!(?:050\-|060\-|070\-|080\-|090\-))(?=.{12,16}$)(?:\d+-){2,}\d+)$/;
        const constraints = {
            tantoshaName: {
                presence: presence(false, commonStore.messages.PV0001),
                length: maxLength(30),
                format: regExpInvalidCharPattern()
            },
            tantoshaTel: {
                presence: presence(false, commonStore.messages.PV0001),
                format: format({ pattern: telPattern, message: commonStore.messages.PV0022 })
            },
            tantoshaEmail: {
                presence: presence(false, commonStore.messages.PV0001),
                email: email(),
                length: maxLength(128)
            },
            henkinBankName: {
                henkinBankRequired: henkinBankRequired(vm, commonStore.messages.PV0002)
            },
            henkinBansName: {
                henkinBankRequired: henkinBankRequired(vm, commonStore.messages.PV0002)
            },
            henkinKouzaSb: {
                henkinBankRequired: henkinBankRequired(vm, commonStore.messages.PV0002)
            },
            henkinKouzaNo: {
                henkinBankRequired: henkinBankRequired(vm, commonStore.messages.PV0001),
                henkinKouzaNoFormat: henkinKouzaNoFormat(vm, commonStore.messages.PV0018, commonStore.messages.PV0025)
            },
            henkinKouzaName: {
                henkinBankRequired: henkinBankRequired(vm, commonStore.messages.PV0001),
                henkinKouzaNameCharFormat: henkinKouzaNameCharFormat(vm),
                henkinKouzaNameMaxLength: henkinKouzaNameMaxLength(vm, 24)
            },
            henkinKouzaKana: {
                henkinBankRequired: henkinBankRequired(vm, commonStore.messages.PV0001),
                henkinKouzaNameFormat: henkinKouzaNameFormat(vm, commonStore.messages.PV0024),
                henkinKouzaNameMaxLength: henkinKouzaNameMaxLength(vm, 48)
            }
        };
        super(vm.model, constraints);
        this.tantoshaName = new ValidationField("tantoshaName", this.data, constraints);
        this.tantoshaTel = new ValidationField("tantoshaTel", this.data, constraints);
        this.tantoshaEmail = new ValidationField("tantoshaEmail", this.data, constraints);
        this.henkinBankName = new ValidationField("henkinBankName", this.data, constraints);
        this.henkinBansName = new ValidationField("henkinBansName", this.data, constraints);
        this.henkinKouzaSb = new ValidationField("henkinKouzaSb", this.data, constraints);
        this.henkinKouzaNo = new ValidationField("henkinKouzaNo", this.data, constraints);
        this.henkinKouzaName = new ValidationField("henkinKouzaName", this.data, constraints);
        this.henkinKouzaKana = new ValidationField("henkinKouzaKana", this.data, constraints);
    }
    tantoshaName;
    tantoshaTel;
    tantoshaEmail;
    henkinBankName;
    henkinBansName;
    henkinKouzaSb;
    henkinKouzaNo;
    henkinKouzaName;
    henkinKouzaKana;
}
export class TaikyoValidator extends Validator {
    constructor(vm, taikyo, taikyoForInput) {
        const telPattern = /^(?:(?:050|060|070|080|090)-\d{4}-\d{4}|(?!(?:050\-|060\-|070\-|080\-|090\-))(?=.{12,16}$)(?:\d+-){2,}\d+)$/;
        const constraints = {
            taikyoYmd: {
                presence: presence(false, commonStore.messages.PV0001),
                dateFormat: dateFormat(commonStore.messages.PV0005),
                isValidate: isValidate(vm, taikyo, commonStore.messages.PV0027, commonStore.messages.PV0031, commonStore.messages.PV0015, taikyoForInput.taikyoDateMaxDays, taikyoForInput.taikyoDateMinDays, taikyoForInput.taikyoMaxDate)
            },
            taikyoRiyuKb: {
                presence: presence(false, commonStore.messages.PV0002)
            },
            taikyoRiyu: {
                taikyoRiyuPresence: taikyoRiyuPresence(vm, taikyo, commonStore.messages.PV0001),
                taikyoRiyuFormat: taikyoRiyuFormat(vm, taikyo),
                taikyoRiyuMaxLength: taikyoRiyuMaxLength(vm, taikyo, 100)
            },
            sonotaKeiyaku: {
                sonotaKeiyakuFormat: sonotaKeiyakuFormat(vm, taikyo),
                sonotaKeiyakuMaxLength: sonotaKeiyakuMaxLength(vm, taikyo, 100)
            },
            renrakuName: {
                renrakuOtherPresence: renrakuOtherPresence(vm, taikyo, taikyoForInput.inputList, commonStore.messages.PV0001),
                renrakuOtherFormat: renrakuOtherFormat(vm, taikyo),
                renrakuOtherMaxLength: renrakuOtherMaxLength(vm, taikyo, 30)
            },
            renrakuRelationship: {
                renrakuOtherPresence: renrakuOtherPresence(vm, taikyo, taikyoForInput.inputList, commonStore.messages.PV0001),
                renrakuOtherFormat: renrakuOtherFormat(vm, taikyo),
                renrakuOtherMaxLength: renrakuOtherMaxLength(vm, taikyo, 30)
            },
            tel: {
                renrakuAllPresence: renrakuAllPresence(vm, taikyo, commonStore.messages.PV0001),
                renrakuAllFormat: renrakuAllFormat(vm, taikyo, telPattern, commonStore.messages.PV0022),
            },
            email: {
                renrakuAllPresence: renrakuAllPresence(vm, taikyo, commonStore.messages.PV0001),
                renrakuAllEmail: renrakuAllEmail(vm, taikyo),
                renrakuAllMaxLength: renrakuAllMaxLength(vm, taikyo, 128)
            },
            keyReturnYmd: {
                keyReturnYmdFormat: keyReturnYmdFormat(vm, taikyo, commonStore.messages.PV0005),
                keyReturnYmdRange: keyReturnYmdRange(vm, taikyo, taikyoForInput.inputList, commonStore.messages.PV0027, commonStore.messages.PV0019)
            },
            numberOfReturnKeys: {
                numberOfReturnKeysRange: numberOfReturnKeysRange(vm, taikyo, 0, 99)
            },
            taikyoTachiaiName: {
                taikyoTachiaiNameFormat: taikyoTachiaiNameFormat(vm, taikyo, taikyoForInput.inputList),
                taikyoTachiaiNameMaxLength: taikyoTachiaiNameMaxLength(vm, taikyo, taikyoForInput.inputList, 30)
            },
            soufuName: {
                soufuNyukyoshaPresence: soufuNyukyoshaPresence(vm, taikyo, commonStore.messages.PV0001),
                soufuNyukyoshaFormat: soufuNyukyoshaFormat(vm, taikyo),
                soufuNyukyoshaMaxLength: soufuNyukyoshaMaxLength(vm, taikyo, 30)
            },
            postCode: {
                soufuHojinNyukyoshaPresence: soufuHojinNyukyoshaPresence(vm, taikyo, commonStore.messages.PV0001),
                soufuHojinNyukyoshaFormat: soufuHojinNyukyoshaFormat(vm, taikyo, /^[0-9]{3}-?[0-9]{4}$/, commonStore.messages.PV0014)
            },
            adr1: {
                soufuHojinNyukyoshaPresence: soufuHojinNyukyoshaPresence(vm, taikyo, commonStore.messages.PV0001),
                soufuHojinNyukyoshaCharFormat: soufuHojinNyukyoshaCharFormat(vm, taikyo),
                soufuHojinNyukyoshaMaxLength: soufuHojinNyukyoshaMaxLength(vm, taikyo, 20)
            },
            adr2: {
                soufuHojinNyukyoshaCharFormat: soufuHojinNyukyoshaCharFormat(vm, taikyo),
                soufuHojinNyukyoshaMaxLength: soufuHojinNyukyoshaMaxLength(vm, taikyo, 20)
            },
            adr3: {
                soufuHojinNyukyoshaCharFormat: soufuHojinNyukyoshaCharFormat(vm, taikyo),
                soufuHojinNyukyoshaMaxLength: soufuHojinNyukyoshaMaxLength(vm, taikyo, 20)
            },
            soufuSonota: {
                soufuOtherPresence: soufuOtherPresence(vm, taikyo, commonStore.messages.PV0001),
                soufuOtherFormat: soufuOtherFormat(vm, taikyo),
                soufuOtherMaxLength: soufuOtherMaxLength(vm, taikyo, 100)
            }
        };
        super(taikyo, constraints);
        this.taikyoYmd = new ValidationField("taikyoYmd", this.data, constraints);
        this.taikyoRiyuKb = new ValidationField("taikyoRiyuKb", this.data, constraints);
        this.taikyoRiyu = new ValidationField("taikyoRiyu", this.data, constraints);
        this.sonotaKeiyaku = new ValidationField("sonotaKeiyaku", this.data, constraints);
        this.renrakuName = new ValidationField("renrakuName", this.data, constraints);
        this.renrakuRelationship = new ValidationField("renrakuRelationship", this.data, constraints);
        this.tel = new ValidationField("tel", this.data, constraints);
        this.email = new ValidationField("email", this.data, constraints);
        this.keyReturnYmd = new ValidationField("keyReturnYmd", this.data, constraints);
        this.numberOfReturnKeys = new ValidationField("numberOfReturnKeys", this.data, constraints);
        this.taikyoTachiaiName = new ValidationField("taikyoTachiaiName", this.data, constraints);
        this.soufuName = new ValidationField("soufuName", this.data, constraints);
        this.postCode = new ValidationField("postCode", this.data, constraints);
        this.adr1 = new ValidationField("adr1", this.data, constraints);
        this.adr2 = new ValidationField("adr2", this.data, constraints);
        this.adr3 = new ValidationField("adr3", this.data, constraints);
        this.soufuSonota = new ValidationField("soufuSonota", this.data, constraints);
    }
    taikyoYmd;
    taikyoRiyuKb;
    taikyoRiyu;
    sonotaKeiyaku;
    renrakuName;
    renrakuRelationship;
    tel;
    email;
    keyReturnYmd;
    numberOfReturnKeys;
    taikyoTachiaiName;
    soufuName;
    postCode;
    adr1;
    adr2;
    adr3;
    soufuSonota;
}
/** 返金先口座の必須チェック */
validate.validators.henkinBankRequired = function (value, options, key, attributes) {
    if (!options.vm.model.isKouzaNotRequired && !options.vm.isMMA) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        }); // 組み込みのpresence
    }
    return null;
};
export function henkinBankRequired(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
/** 返金先口座番号のフォーマットチェック */
validate.validators.henkinKouzaNoFormat = function (value, options, key, attributes) {
    if (!options.vm.model.isKouzaNotRequired && !options.vm.isMMA) {
        const kouzaNoPattern = new RegExp(/^\d{7}$/);
        const irregKouzaNo = new RegExp(/^(?!0{7}$)\d{7}$/);
        if (!RegExp(kouzaNoPattern).test(value)) {
            return validate.validators.format(value, {
                pattern: kouzaNoPattern,
                message: options.kouzaNoFormat
            });
        }
        if (!RegExp(irregKouzaNo).test(value)) {
            return validate.validators.format(value, {
                pattern: irregKouzaNo,
                message: options.irregKouzaNoFormat
            });
        }
    }
    return null;
};
export function henkinKouzaNoFormat(vm, kouzaNoFormat, irregKouzaNoFormat) {
    return {
        vm: vm,
        kouzaNoFormat: kouzaNoFormat,
        irregKouzaNoFormat: irregKouzaNoFormat
    };
}
/** 返金先口座名のフォーマットチェック */
validate.validators.henkinKouzaNameCharFormat = function (value, options, key, attributes) {
    if (!options.vm.model.isKouzaNotRequired && !options.vm.isMMA) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function henkinKouzaNameCharFormat(vm) {
    return {
        vm: vm
    };
}
/** 返金先口座名のフォーマットチェック */
validate.validators.henkinKouzaNameFormat = function (value, options, key, attributes) {
    const KouzaKanaPattern = /^[ｦ-ﾟ A-Z0-9().,-/¥｢｣]+$/;
    if (!options.vm.model.isKouzaNotRequired && !options.vm.isMMA) {
        return validate.validators.format(value, {
            pattern: KouzaKanaPattern,
            message: options.message
        });
    }
    return null;
};
export function henkinKouzaNameFormat(vm, message) {
    return {
        vm: vm,
        message: message
    };
}
/** 返金先口座名の最大文字数チェック */
validate.validators.henkinKouzaNameMaxLength = function (value, options, key, attributes) {
    if (!options.vm.model.isKouzaNotRequired && !options.vm.isMMA) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function henkinKouzaNameMaxLength(vm, maximum) {
    return {
        vm: vm,
        maximum: maximum
    };
}
/** 退去予定日 過日/超過チェック  */
validate.validators.isValidate = function (value, options, key, attributes) {
    let minDays = !isNullOrUndefined(options.min) ? options.min : 0;
    if (typeof value === "undefined" || value === null || value === "") {
        return MypageMessageFormat(options.messageToday, { val: options.context });
    }
    let taikyoYmd = dayjs(value);
    let today = dayjs().startOf("day");
    if (!dayjs(taikyoYmd).isValid()) {
        if (minDays != 0) {
            return MypageMessageFormat(options.messageMin, { val: options.min });
        }
        return MypageMessageFormat(options.messageToday, { val: null });
    }
    // 退去予定日が本日から最低日数を超えていない場合。
    if (taikyoYmd.isBefore(today.add(minDays, 'day'))) {
        if (minDays != 0) {
            return MypageMessageFormat(options.messageMin, { val: options.min });
        }
        return MypageMessageFormat(options.messageToday, { val: null });
    }
    // 本日から退去予定日までの日数が最大日数を超える場合
    let daysUntilTaikyo = taikyoYmd.diff(today, "day", true);
    if (daysUntilTaikyo > options.max) {
        const daysUntilMaxDate = dayjs(options.maxDate).diff(today, "day", true);
        // 以下の条件を満たす場合、最大日付（汎用区分：4、汎用マスタ.オプション3）のエラーメッセージを表示
        // 最大日付が設定されている（NULL以外）
        // 最大日付が未来日
        // 本日から最大日付までの日数が最大日数を超える
        if (!isNullOrUndefined(options.maxDate) && !today.isAfter(dayjs(options.maxDate)) && daysUntilMaxDate > options.max) {
            // 退去予定日が最大日付を超える
            if (taikyoYmd.isAfter(dayjs(options.maxDate))) {
                // const maxDate = dayjs(options.maxDate).format("YYYY年MM月DD");
                // return MypageMessageFormat(options.messageMax, { val: maxDate });
                return MypageMessageFormat(options.messageMax, { val: options.max });
            }
            // 退去予定日が最大日付を超えなかった場合、エラーを表示しない
            return null;
        }
        // それ以外
        return MypageMessageFormat(options.messageMax, { val: options.max });
    }
    if (taikyoYmd < today) {
        return MypageMessageFormat(options.messageMin, { val: null });
    }
    return null;
};
export function isValidate(vm, taikyo, messageToday, messageMin, messageMax, max, min, maxDate) {
    return {
        vm: vm,
        taikyo: taikyo,
        messageToday: messageToday,
        messageMin: messageMin,
        messageMax: messageMax,
        max: max,
        min: min,
        maxDate: maxDate
    };
}
/** 退去理由その他が活性状態の場合にのみ必須チェック */
validate.validators.taikyoRiyuPresence = function (value, options, key, attributes) {
    // 退去理由その他が活性状態の場合にのみバリデーション
    if (!options.vm.isDisableTaikyoRiyu(options.taikyo)) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        }); // 組み込みのpresence
    }
    return null;
};
export function taikyoRiyuPresence(vm, taikyo, message) {
    return {
        vm: vm,
        taikyo: taikyo,
        message: message
    };
}
/** 退去理由その他が活性状態の場合にのみフォーマットチェック */
validate.validators.taikyoRiyuFormat = function (value, options, key, attributes) {
    if (!options.vm.isDisableTaikyoRiyu(options.taikyo)) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function taikyoRiyuFormat(vm, taikyo) {
    return {
        vm: vm,
        taikyo: taikyo
    };
}
/** 退去理由その他が活性状態の場合にのみ最大文字数チェック */
validate.validators.taikyoRiyuMaxLength = function (value, options, key, attributes) {
    // 退去理由その他が活性状態の場合にのみバリデーション
    if (!options.vm.isDisableTaikyoRiyu(options.taikyo)) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function taikyoRiyuMaxLength(vm, taikyo, maximum) {
    return {
        vm: vm,
        taikyo: taikyo,
        maximum: maximum
    };
}
/** その他ご契約事項が活性状態の場合にのみフォーマットチェック */
validate.validators.sonotaKeiyakuFormat = function (value, options, key, attributes) {
    if (!options.vm.isParking(options.taikyo)) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function sonotaKeiyakuFormat(vm, taikyo) {
    return {
        vm: vm,
        taikyo: taikyo
    };
}
/** その他ご契約事項が活性状態の場合にのみ最大文字数チェック */
validate.validators.sonotaKeiyakuMaxLength = function (value, options, key, attributes) {
    // その他ご契約事項が活性状態の場合にのみバリデーション
    if (!options.vm.isParking(options.taikyo)) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function sonotaKeiyakuMaxLength(vm, taikyo, maximum) {
    return {
        vm: vm,
        taikyo: taikyo,
        maximum: maximum
    };
}
/** 連絡先区分（その他）が活性状態の場合にのみ必須チェック */
validate.validators.renrakuOtherPresence = function (value, options, key, attributes) {
    // 連絡先氏名が活性状態の場合にのみバリデーション
    const renrakuKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.renrakuKb;
    if (renrakuKb === RenrakuKb.Other) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        });
    }
    return null;
};
export function renrakuOtherPresence(vm, taikyo, inputList, message) {
    return {
        vm: vm,
        taikyo: taikyo,
        message: message
    };
}
/** 連絡先区分（その他）が活性状態の場合にのみフォーマットチェック */
validate.validators.renrakuOtherFormat = function (value, options, key, attributes) {
    const renrakuKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.renrakuKb;
    if (renrakuKb === RenrakuKb.Other) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function renrakuOtherFormat(vm, taikyo) {
    return {
        vm: vm,
        taikyo: taikyo
    };
}
/** 連絡先区分（その他）が活性状態の場合にのみ最大文字数チェック */
validate.validators.renrakuOtherMaxLength = function (value, options, key, attributes) {
    // 連絡先区分（その他）が活性状態の場合にのみバリデーション
    const renrakuKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.renrakuKb;
    if (renrakuKb === RenrakuKb.Other) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function renrakuOtherMaxLength(vm, taikyo, maximum) {
    return {
        vm: vm,
        taikyo: taikyo,
        maximum: maximum
    };
}
/** 連絡先が活性状態の場合にのみ必須チェック */
validate.validators.renrakuAllPresence = function (value, options, key, attributes) {
    // 連絡先氏名が活性状態の場合にのみバリデーション
    const allRenrakuKbs = [RenrakuKb.Hojin, RenrakuKb.Nyukyosha, RenrakuKb.Other];
    const renrakuKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.renrakuKb;
    if (allRenrakuKbs.includes(renrakuKb)) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        });
    }
    return null;
};
export function renrakuAllPresence(vm, taikyo, message) {
    return {
        vm: vm,
        taikyo: taikyo,
        message: message
    };
}
/** 連絡先が活性状態の場合にのみフォーマットチェック */
validate.validators.renrakuAllFormat = function (value, options, key, attributes) {
    const allRenrakuKbs = [RenrakuKb.Hojin, RenrakuKb.Nyukyosha, RenrakuKb.Other];
    const renrakuKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.renrakuKb;
    if (allRenrakuKbs.includes(renrakuKb)) {
        return validate.validators.format(value, {
            pattern: options.pattern,
            message: options.message
        });
    }
    return null;
};
export function renrakuAllFormat(vm, taikyo, pattern, message) {
    return {
        vm: vm,
        taikyo: taikyo,
        pattern: pattern,
        message: message
    };
}
/** 連絡先が活性状態の場合にのみメールアドレスフォーマットチェック */
validate.validators.renrakuAllEmail = function (value, options, key, attributes) {
    const allRenrakuKbs = [RenrakuKb.Hojin, RenrakuKb.Nyukyosha, RenrakuKb.Other];
    const renrakuKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.renrakuKb;
    if (allRenrakuKbs.includes(renrakuKb)) {
        return validate.validators.email.call(validate.validators.email, value, email());
    }
    return null;
};
export function renrakuAllEmail(vm, taikyo) {
    return {
        vm: vm,
        taikyo: taikyo
    };
}
/** 連絡先が活性状態の場合にのみ最大文字数チェック */
validate.validators.renrakuAllMaxLength = function (value, options, key, attributes) {
    // 連絡先が活性状態の場合にのみバリデーション
    const allRenrakuKbs = [RenrakuKb.Hojin, RenrakuKb.Nyukyosha, RenrakuKb.Other];
    const renrakuKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.renrakuKb;
    if (allRenrakuKbs.includes(renrakuKb)) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function renrakuAllMaxLength(vm, taikyo, maximum) {
    return {
        vm: vm,
        taikyo: taikyo,
        maximum: maximum
    };
}
/** 鍵渡予定日のdatetime of dateフォーマットチェック */
validate.validators.keyReturnYmdFormat = function (value, options, key, attributes) {
    if (isNullOrUndefined(value)) {
        return null;
    }
    const dateFormatKeyReturnNameKbs = [KeyReturnNameKb.PreferredAttendanceDatetime, KeyReturnNameKb.KeyReturnScheduledDatetime];
    const keyReturnNameKb = options.vm.taikyoForInput?.inputList.find((x) => x.orgNyukyokeiyakuNo === attributes.taikyoNo)?.keyReturnNameKb;
    if (dateFormatKeyReturnNameKbs.includes(keyReturnNameKb)) {
        const dateTimeFormatPattern = new RegExp(/^([12]\d{3}\/(0?[1-9]|1[0-2])\/(0?[1-9]|[12][0-9]|3[01])\s([01]?\d|2[0-3]):[0-5]\d)?$/);
        if (!value.match(dateTimeFormatPattern)) {
            return options.message;
        }
        const dateStr = value.split(" ")[0];
        // 2022/1/32等の不正な日付はInvalid Date
        const date = new Date(dateStr);
        if (Number.isNaN(date.getTime())) {
            return options.message;
        }
        // 2022/11/31などをDateに直した際に、2022/12/01になることを利用した日付チェック
        const sp = dateStr.split("/");
        const year = Number(sp[0]);
        const month = Number(sp[1]);
        const day = Number(sp[2]);
        if (year !== date.getFullYear() || month !== date.getMonth() + 1 || day !== date.getDate()) {
            return options.message;
        }
    }
    else {
        return validate.validators.dateFormat(value, { message: options.message }); // 既存のdateformat
    }
    return null;
};
export function keyReturnYmdFormat(vm, taikyo, message) {
    return {
        vm: vm,
        taikyo: taikyo,
        message: message
    };
}
/** 鍵渡予定日に応じた鍵返却予定日時範囲チェック */
validate.validators.keyReturnYmdRange = function (value, options, key, attributes) {
    if (isNullOrUndefined(value)) {
        return null;
    }
    const forInput = options.vm.taikyoForInput?.inputList.find((x) => x.orgNyukyokeiyakuNo === attributes.taikyoNo);
    const keyReturnMinTime = forInput?.keyReturnMinTime;
    const keyReturnMaxTime = forInput?.keyReturnMaxTime;
    const kaiyakuYmd = attributes.kaiyakuYmd;
    const dateStr = value.split(" ")[0];
    const timeStr = value.split(" ")[1];
    // 鍵返却予定日
    const targetDate = dayjs(dateStr + " 00:00");
    const today = dayjs(dayjs().format("YYYY/MM/DD") + " 00:00");
    const msgOutOfRange = `${keyReturnMinTime}～${keyReturnMaxTime}の範囲で入力してください。`;
    if (targetDate.isBefore(today)) {
        return options.isBeforeTodayMessage;
    }
    if (targetDate.isAfter(dayjs(kaiyakuYmd))) {
        return options.isAfterKaiyakuYmdMessage;
    }
    const dateFormatKeyReturnNameKbs = [KeyReturnNameKb.PreferredAttendanceDatetime, KeyReturnNameKb.KeyReturnScheduledDatetime];
    const keyReturnNameKb = forInput?.keyReturnNameKb;
    if (dateFormatKeyReturnNameKbs.includes(keyReturnNameKb)) {
        // 鍵返却予定日時
        const targetDatetime = dayjs(dateStr + " " + timeStr);
        const openTime = dayjs(dateStr + " " + keyReturnMinTime);
        const closeTime = dayjs(dateStr + " " + keyReturnMaxTime);
        // 日付日時フォーマット
        if (targetDatetime.isBefore(openTime)) {
            return msgOutOfRange;
        }
        if (targetDatetime.isAfter(closeTime)) {
            return msgOutOfRange;
        }
    }
    return null;
};
export function keyReturnYmdRange(vm, taikyo, forInputList, isBeforeTodayMessage, isAfterKaiyakuYmdMessage) {
    return {
        vm: vm,
        taikyo: taikyo,
        forInputList: forInputList,
        isBeforeTodayMessage: isBeforeTodayMessage,
        isAfterKaiyakuYmdMessage: isAfterKaiyakuYmdMessage
    };
}
/** 鍵返却予定数が活性状態の場合にのみ最大文字数チェック */
validate.validators.numberOfReturnKeysRange = function (value, options, key, attributes) {
    // 鍵返却予定数が活性状態の場合にのみバリデーション
    const dateFormatKeyReturnNameKbs = [KeyReturnNameKb.PreferredAttendanceDatetime, KeyReturnNameKb.KeyReturnScheduledDatetime];
    const keyReturnNameKb = options.vm.taikyoForInput?.inputList.find((x) => x.orgNyukyokeiyakuNo === attributes.taikyoNo)?.keyReturnNameKb;
    if (dateFormatKeyReturnNameKbs.includes(keyReturnNameKb)) {
        return validate.validators.range(value, range(options.minimum, options.maximum)); // 既存のrange
    }
    return null;
};
export function numberOfReturnKeysRange(vm, taikyo, minimum, maximum) {
    return {
        vm: vm,
        taikyo: taikyo,
        minimum: minimum,
        maximum: maximum
    };
}
/** 退去立会名が活性状態の場合にのみフォーマットチェック */
validate.validators.taikyoTachiaiNameFormat = function (value, options, key, attributes) {
    const isTachiai = options.inputList.find((x) => x.orgNyukyokeiyakuNo === attributes.taikyoNo).keyReturnNameKb === KeyReturnNameKb.PreferredAttendanceDatetime;
    if (isTachiai) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function taikyoTachiaiNameFormat(vm, taikyo, inputList) {
    return {
        vm: vm,
        taikyo: taikyo,
        inputList: inputList
    };
}
/** 退去立会名が活性状態の場合にのみ最大文字数チェック */
validate.validators.taikyoTachiaiNameMaxLength = function (value, options, key, attributes) {
    // 退去立会名が活性状態の場合にのみバリデーション
    const isTachiai = options.inputList.find((x) => x.orgNyukyokeiyakuNo === attributes.taikyoNo).keyReturnNameKb === KeyReturnNameKb.PreferredAttendanceDatetime;
    if (isTachiai) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function taikyoTachiaiNameMaxLength(vm, taikyo, inputList, maximum) {
    return {
        vm: vm,
        taikyo: taikyo,
        inputList: inputList,
        maximum: maximum
    };
}
/** 送付先区分（入居者）が活性状態の場合にのみ必須チェック */
validate.validators.soufuNyukyoshaPresence = function (value, options, key, attributes) {
    // 送付先区分（入居者）が活性状態の場合にのみバリデーション
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    if (keyReturnAdrKb === KeyReturnAdrKb.Nyukyosha) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        });
    }
    return null;
};
export function soufuNyukyoshaPresence(vm, taikyo, message) {
    return {
        vm: vm,
        taikyo: taikyo,
        message: message
    };
}
/** 送付先区分（入居者）が活性状態の場合にのみフォーマットチェック */
validate.validators.soufuNyukyoshaFormat = function (value, options, key, attributes) {
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    if (keyReturnAdrKb === KeyReturnAdrKb.Nyukyosha) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function soufuNyukyoshaFormat(vm, taikyo) {
    return {
        vm: vm,
        taikyo: taikyo
    };
}
/** 送付先区分（入居者）が活性状態の場合にのみ最大文字数チェック */
validate.validators.soufuNyukyoshaMaxLength = function (value, options, key, attributes) {
    // 送付先区分（入居者）が活性状態の場合にのみバリデーション
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    if (keyReturnAdrKb === KeyReturnAdrKb.Nyukyosha) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function soufuNyukyoshaMaxLength(vm, taikyo, maximum) {
    return {
        vm: vm,
        taikyo: taikyo,
        maximum: maximum
    };
}
/** 送付先区分（入居者 または 法人）が活性状態の場合にのみ必須チェック */
validate.validators.soufuHojinNyukyoshaPresence = function (value, options, key, attributes) {
    // 送付先区分（入居者 または 法人）が活性状態の場合にのみバリデーション
    const selectebleSoufu = [KeyReturnAdrKb.Hojin, KeyReturnAdrKb.Nyukyosha];
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    if (selectebleSoufu.includes(keyReturnAdrKb)) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        });
    }
    return null;
};
export function soufuHojinNyukyoshaPresence(vm, taikyo, message) {
    return {
        vm: vm,
        taikyo: taikyo,
        message: message
    };
}
/** 送付先区分（入居者 または 法人）が活性状態の場合にのみフォーマットチェック */
validate.validators.soufuHojinNyukyoshaFormat = function (value, options, key, attributes) {
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    const selectebleSoufu = [KeyReturnAdrKb.Hojin, KeyReturnAdrKb.Nyukyosha];
    if (selectebleSoufu.includes(keyReturnAdrKb)) {
        return validate.validators.format(value, {
            pattern: options.pattern,
            message: options.message
        });
    }
    return null;
};
export function soufuHojinNyukyoshaFormat(vm, taikyo, pattern, message) {
    return {
        vm: vm,
        taikyo: taikyo,
        pattern: pattern,
        message: message
    };
}
/** 連絡先区分（入居者 または 法人）が活性状態の場合にのみフォーマットチェック */
validate.validators.soufuHojinNyukyoshaCharFormat = function (value, options, key, attributes) {
    const selectebleSoufu = [KeyReturnAdrKb.Hojin, KeyReturnAdrKb.Nyukyosha];
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    if (selectebleSoufu.includes(keyReturnAdrKb)) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function soufuHojinNyukyoshaCharFormat(vm, taikyo) {
    return {
        vm: vm,
        taikyo: taikyo
    };
}
/** 送付先区分（入居者）が活性状態の場合にのみ最大文字数チェック */
validate.validators.soufuHojinNyukyoshaMaxLength = function (value, options, key, attributes) {
    const selectebleSoufu = [KeyReturnAdrKb.Hojin, KeyReturnAdrKb.Nyukyosha];
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    // 送付先区分（入居者）が活性状態の場合にのみバリデーション
    if (selectebleSoufu.includes(keyReturnAdrKb)) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function soufuHojinNyukyoshaMaxLength(vm, taikyo, maximum) {
    return {
        vm: vm,
        taikyo: taikyo,
        maximum: maximum
    };
}
/** 送付先区分（その他）が活性状態の場合にのみ必須チェック */
validate.validators.soufuOtherPresence = function (value, options, key, attributes) {
    // 送付先区分（その他）が活性状態の場合にのみバリデーション
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    if (keyReturnAdrKb === KeyReturnAdrKb.Other) {
        return validate.validators.presence(value, {
            allowEmpty: false,
            message: options.message
        });
    }
    return null;
};
export function soufuOtherPresence(vm, taikyo, message) {
    return {
        vm: vm,
        taikyo: taikyo,
        message: message
    };
}
/** 連絡先区分（その他）が活性状態の場合にのみフォーマットチェック */
validate.validators.soufuOtherFormat = function (value, options, key, attributes) {
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    if (keyReturnAdrKb === KeyReturnAdrKb.Other) {
        return validate.validators.format(value, regExpInvalidCharPattern());
    }
    return null;
};
export function soufuOtherFormat(vm, taikyo) {
    return {
        vm: vm,
        taikyo: taikyo
    };
}
/** 送付先区分（その他）が活性状態の場合にのみ最大文字数チェック */
validate.validators.soufuOtherMaxLength = function (value, options, key, attributes) {
    const keyReturnAdrKb = options.vm.model.taikyoList.find((x) => x.taikyoNo === attributes.taikyoNo)?.keyReturnAdrKb;
    if (keyReturnAdrKb === KeyReturnAdrKb.Other) {
        return validate.validators.length(value, maxLength(options.maximum));
    }
    return null;
};
export function soufuOtherMaxLength(vm, taikyo, maximum) {
    return {
        vm: vm,
        taikyo: taikyo,
        maximum: maximum
    };
}
